import React, { ReactNode, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './pages/Homepage';
import VerificationForm from './components/VerificationForm';
import PrivacyPolicy from './components/PrivacyPolicy';
import AdminLogin from './components/AdminLogin';
import ProtectedRoute from './components/ProtectedRoute';
import Submissions from './components/Submissions';
import Verifications from './components/Verifications';
import Layout from './components/Layout';
import { Outlet } from 'react-router-dom';
import Users from './components/Users';
import { Toaster } from 'sonner';
import Logs from './components/Logs';
import ResetPassword from './components/ResetPassword';
import SendResetLink from './components/SendResetLink';

const App: React.FC = () => {
	const [isAdmin, setIsAdmin] = useState(false);

	const handleLogin = (adminStatus: boolean) => {
		setIsAdmin(adminStatus);
	};

	const handleLogout = () => {
		setIsAdmin(false);
	};

	return (
		<>
			<Router>
				<Routes>
					{/* Public routes */}
					<Route path="/" element={<HomePage />} />
					<Route path="/verify" element={<VerificationForm />} />
					<Route path="/privacy" element={<PrivacyPolicy />} />
					<Route path="/admin" element={<AdminLogin onLogin={handleLogin} />} />
					<Route path="/send-reset-link" element={<SendResetLink />} />
					<Route path="/reset-password" element={<ResetPassword />} />

					{/* Protected routes with shared layout */}
					<Route
						element={
							<Layout onLogout={handleLogout}>
								<Outlet /> {/* Nested routes render here */}
							</Layout>
						}
					>
						<Route
							path="/dashboard"
							element={
								<ProtectedRoute isAdmin={isAdmin}>
									<Submissions isAdmin={isAdmin} onLogout={handleLogout} />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/verifications"
							element={
								<ProtectedRoute isAdmin={isAdmin}>
									<Verifications />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/users"
							element={
								<ProtectedRoute isAdmin={isAdmin}>
									<Users />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/logs"
							element={
								<ProtectedRoute isAdmin={isAdmin}>
									<Logs />
								</ProtectedRoute>
							}
						/>
					</Route>
				</Routes>
			</Router>
			<Toaster position="bottom-right" richColors />
		</>
	);
};

export default App;
